<template>
  <div class="thread-section">
    <v-skeleton-loader
      class="ma-4"
      type="card"
      v-if="loadComponent"
    ></v-skeleton-loader>
    <div v-else>
      <v-card flat v-if="ticketThreadSection">
        <v-list v-if="threadList.length">
          <v-list-item-group
            v-model="selectedItem"
            color="primary"
            v-for="(thread, index) in threadList"
            :key="thread.title"
          >
            <v-list-item class="px-6">
              <v-list-item-content>
                <v-list-item-title class="body-1 cursor-pointer" @click="showThreadDetail(thread)">
                  <div class="pb-1">
                    <span> From: {{ thread.user.agent_name }} </span>
                    <span class="body-2 grey--text text--darken-2 text-capitalize"> {{ thread.created_at | formatDate }} </span>
                  </div>
                  <div class="d-block to-field overflow-hidden">
                    <template>
                      <div class="text-truncate width-80 float-left"> To: <span class="grey--text text--darken-2">{{ thread.to_emails[0] }}</span> </div>
                    </template>
                  </div>
                  <div class="pt-2 d-block">
                    <div v-html="filterBodyFromThread(thread)" class="text-truncate"></div>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action class="mt-0 mt-n7" v-if="ticketData.status !== 'closed' && !ticketAccess.deleted">
                <v-btn icon @click.stop="deleteThread(thread)"
                v-track="'delete-forward-thread-btn'">
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-divider :key="index"></v-divider>
          </v-list-item-group>
        </v-list>
        <div v-else class="pa-6 grey--text text--darken-3"> When you forward the ticket to someone, your conversation will be shown here.</div>
      </v-card>

      <div class="thread-detail-section mt-6 mr-2" v-else-if="threadDetailSection">
        <div class="d-flex width-100">
          <div class="back-arrow px-1 cursor-pointer" @click="backToList()">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small v-bind="attrs" v-on="on">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
              </template>
              <span class="caption">Back</span>
            </v-tooltip>
          </div>
          <div class="width-100 overflow-hidden">
            <v-card class="body-1 d-block mr-2 pt-1 mb-3" flat 
             v-for="(comment, index) in threadComments" :key="index"
             :color="comment.incoming ? '#EFF4F8':'#EEEEEE'">
              <div class="px-4 overflow-hidden">
                <div class="py-2 body-2 d-flex">
                  <div class="text-truncate max-width-200 pr-1">
                    <span class="font-weight-medium text-capitalize" v-if="returnUserName(comment.user)">
                      {{ returnUserName(comment.user) }}
                    </span>
                    <span class="font-weight-medium" v-else>
                      {{ comment.user.email }}
                    </span>
                  </div>
                  <span class="grey--text text--darken-2 text-capitalize"> {{ comment.created_at | formatDate }}</span>
                </div>
                <div class="d-block to-field overflow-hidden">
                  <template>
                    <div class="text-truncate width-80 float-left"> To: <span class="grey--text text--darken-2">{{ comment.to_emails[0] }}</span> </div>
                    <v-menu offset-y attach left max-width="250px">
                      <template v-slot:activator="{ on, attrs }">
                        <a v-if="comment.to_emails.length > 1" class="ma-1" v-bind="attrs" v-on="on">
                          +{{ comment.to_emails.length - 1 }} more
                        </a>
                      </template>
                      <v-list class="menu-list">
                        <v-list-item-group>
                          <v-list-item v-for="(toEmail, index) in comment.to_emails" :key="index">
                            <span class="text-truncate d-block menu-width">{{ toEmail }}</span>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-menu>
                  </template>
                </div>

                <div class="d-block to-field" v-if="comment.cc_emails && comment.cc_emails.length"> Cc:
                  <template>
                    <span class="grey--text text--darken-2"> {{ comment.cc_emails[0] }} </span>
                    <v-menu offset-y attach left max-width="250px">
                      <template v-slot:activator="{ on, attrs }">
                        <a v-if="comment.cc_emails.length > 1" class="ma-1" v-bind="attrs" v-on="on">
                          +{{ comment.cc_emails.length - 1 }} more
                        </a>
                      </template>
                      <v-list class="menu-list">
                        <v-list-item-group>
                          <v-list-item v-for="(ccEmail, index) in comment.cc_emails" :key="index"
                          v-show="index >= 1">
                            <span class="text-truncate d-block menu-width">{{ ccEmail }}</span>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-menu>
                  </template>
                </div>
              </div>
              <div class="py-2"><v-divider></v-divider></div>
              <div class="py-2 px-4 d-block thread-comment-body">
                <div v-html="filterBodyFromThread(comment)"></div>
                <!--- quoted text--->
                  <div
                    class="chain-messsages"
                    v-if="checkToShowThreadIcon(comment, index) || comment.comment_type == 'forward' "
                  >
                    <v-tooltip right>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          v-track="'hide-reply-chain-click'"
                          @click="createReplyChain(comment, index) "
                          >mdi-dots-horizontal</v-icon
                        >
                      </template>
                     <span class="caption" >
                           {{index == currentCommentIndex && toggleCommentChain 
                           ? 'Hide quoted text': 'Show quoted text' }}
                     </span>
                    </v-tooltip>
                    <div
                      class="mt-2"
                      v-if="index == currentCommentIndex && toggleCommentChain"
                    >
                      <div
                        class="service-cloud-quote"
                        v-html="commentChainHtml"
                      ></div>
                    </div>
                  </div>
              </div>
              <div class="pl-4 pb-4" v-if="comment.attachment_info.length">
                <h3 class="body-2">
                  <span class="secondary--font font-weight-600 black--text">
                    Attachments ({{ comment.attachment_info.length }})
                  </span>
                </h3>
                <ShowAttachments :fileData="comment" :key="loadComponent" size="small"></ShowAttachments>
              </div>
            </v-card>
             <div class="d-block mt-5" v-if="showReplyButton && $can('create', 'tickets')"> 
              <v-btn outlined class="font-weight-bold" :disabled="supportEmailList.length == 0 || ticketData.status === 'closed'
               || ticketAccess.contactRemoved || ticketAccess.deleted"
               v-track="'reply-on-single-thread'" @click="addThreadReply"> Reply </v-btn> 
             </div>
          </div>
        </div>
        <div class="mt-5">
          <reply-editor
            v-if="showThreadReplySection"
            :ticketData="ticketData"
            @onReply="getThreadComments"
            @oncancel="cancelThreadReplySection"
            :supportEmailList="supportEmailList"
            commentType="thread_reply"
            :lastCommentData="lastComment"
            >
          </reply-editor>
        </div>
      </div>
    </div>
    <!-- delete thread dialog -->
    <dialog-box v-bind="dialog.attrs" v-on="dialog.on" />
  </div>
</template>

<script>
import { $tickets } from "@/services/Index";
import ShowAttachments from "@/components/tickets/reply/ShowAttachments";
import ReplyEditor from '@/components/tickets/reply/ReplyEditor';
import { commentMixin } from "@/mixins/comments.js";
import DialogBox from "@core/components/ui/DialogBox";

export default {
  mixins: [commentMixin],
  props: {
    ticketData: {
      type: [Object, Array],
      default: ()=> ({})
    },
    supportEmailList:{
      type: [Object, Array],
      default: ()=> ([])
    },
    threadId:{
     type: [Number, String],
     default: 0
    },
    ticketAccess: {
      type: Object,
      default: ()=> ({})
    },
  },

  components: {
    ShowAttachments,
    ReplyEditor,
    DialogBox
  },
  data() {
    return {
      selectedItem: null,
      loadComponent: true,
      ticketThreadSection: true,
      threadDetailSection: false,
      threadList: [],
      singleThread: {},
      threadComments: [],
      pageNo: 1,
      totalCount: null,
      showThreadReplySection:false,
      showReplyButton: false,
      lastComment:null,
      selectedThread:{},
      dialog: {
        attrs: {
          show: false,
          title: "Delete Thread",
          subtitle:'Are you sure you want to delete this thread ?',
          message:'Warning: You cannot undo this action',
          loading: false,
          confirmBtn: true,
          confirmationText: "Delete",
        },
        on: {
          confirm: this.onConfirm,
          cancel: () => {
            this.dialog.attrs.show = false;
          },
        },
      },
      loadThreadDetail: false
    }
  },

  computed: {
    ticketId() {
      return this.$route.params.id
    }
  },
  mounted() {
    this.getThreadList(this.ticketId)
    this.threadScrollListener()
    if(this.threadId) this.loadThreadDetail = true
  },

  methods: {
    async getThreadList(ticketId) {
      this.loadComponent = true;
      try {
        let queryParams = {
          per_page: 10,
          page: this.pageNo,
        }
        const response = await $tickets.getThreads(ticketId, { params: queryParams });
        if (response.data) {
          if (this.pageNo == 1) {
            this.threadList = response.data.ticket_threads;
          } else {
            this.threadList = [
              ...this.threadList,
              ...response.data.ticket_threads,
            ];
          }
          this.totalCount = response.data.pagination.total_count

          if(this.loadThreadDetail){ 
            const currentThread = this.threadList.find(item => item.id === this.threadId);
            this.showThreadDetail(currentThread)
          }
          this.loadComponent = false;
        }
      } catch (error) {
        // Log any errors from the try block or API
          console.error('An error occurred:', error);
      }
    },

    showThreadDetail(thread) {
      this.selectedThread = thread
      this.ticketThreadSection = false
      this.threadDetailSection = true
      this.getThreadComments()
      //scrolling to bottom after getting all thread comment
      setTimeout(function () {
        let element = document.getElementById("section-scrolldiv");
        element.scrollTop = element.scrollHeight;
      }, 1000);
    },

    async getThreadComments() {
      this.loadComponent = true
      let payload = {
        id: this.selectedThread.id
      }
      try {
        const response = await $tickets.threadComments(this.ticketId, payload, {});
        if (response.data) {
          this.threadComments = response.data.ticket_comments;
          this.lastComment = this.getLastComment()
          this.loadComponent = false;
          this.showReplyButton = true
        }
      } catch (error) {
        // Log any errors from the try block or API
          console.error('An error occurred:', error);
      }
    },

   getLastComment() {
      if (this.threadComments.length > 0) {
        return this.threadComments[this.threadComments.length - 1];
      }
    },

    backToList() {
      this.ticketThreadSection = true
      this.threadDetailSection = false
    },


    filterBodyFromThread(comment) {
      let planer = require("planer");
      return planer.extractFrom(comment.body, "text/html", window.document);
    },

    threadScrollListener() {
      const selectorClass = ".right-side-scroll";
      let element = document.querySelector(selectorClass);
      if (element) {
        element.addEventListener("scroll", this.onScroll);
      }
    },

    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight) {
        if (this.threadList.length < this.totalCount) {
          this.pageNo = this.pageNo + 1;
          this.getThreadList(this.ticketId);
        }
      }
    },

    addThreadReply(){
      this.showReplyButton = false
      this.showThreadReplySection = true
    },

    cancelThreadReplySection() {
      this.showThreadReplySection = false;
      this.showReplyButton = true
    },

    returnUserName(user) {
        return `${user.first_name || ''} ${user.last_name || ''}`.trim();
    },

    deleteThread(thread){
      this.selectedThread = thread
      this.dialog.attrs.show = true;
    },

    async onConfirm() {
      let payload = {
        id: this.selectedThread.id
      }
      try {
        const response = await $tickets.deleteThread(this.ticketId, payload, {});
        if (response.data) {
          this.dialog.attrs.show = false;
          this.$emit("reloadCommentSection");
          this.loadThreadDetail = false
          this.getThreadList(this.ticketId)
          this.$store.dispatch("ui/snackbar", [
            {
              message: `Thread deleted successfully.`,
              type: "success",
            },
          ]);
          
        }
      } catch (error) {
        // Log any errors from the try block or API
          console.error('An error occurred:', error);
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .to-field {
    white-space: normal !important;
  }
  .thread-section {
    padding-bottom: 100px;
  }
  .width-80 {
    max-width: 80%;
    padding-right: 4px;
  }
</style>
